import React from 'react';
import { motion } from 'framer-motion';
import { Reveal } from '../Reveal';
import { PillButton } from '../PillButton';
import { ProductVisual } from '../products/ProductVisual';
import { products } from '../../data/products';
interface FamilyScreenProps {
  onNext: () => void;
}
export function FamilyScreen({
  onNext
}: FamilyScreenProps) {
  return <div className="flex flex-1 flex-col justify-center py-4" data-id="element-297" data-mp="332tlwrs0hsya">
      <Reveal data-id="element-298" data-mp="2fgdbtjk9qfm0">
        <span className="font-body text-[10px] uppercase tracking-[0.22em] text-primary" data-id="element-299" data-mp="2ffv7s0rd6x3j">
          The family portrait
        </span>
      </Reveal>
      <Reveal delay={0.06} data-id="element-300" data-mp="2p4v9vt15y8ly">
        <h2 className="mt-2 font-heading text-[42px] leading-[0.95] tracking-[-0.02em] text-white" data-id="element-301" data-mp="2p66o6ms8iyrb">
          Meet the Filtek’s
        </h2>
      </Reveal>
      <Reveal delay={0.14} data-id="element-302" data-mp="2kclqkvuk06sn">
        <p className="mt-3 max-w-[310px] font-body text-[15px] leading-relaxed text-white/65" data-id="element-303" data-mp="1woavyafgb3ct">
          Three composites and one late arrival. Same heritage, different strengths
          for different jobs.
        </p>
      </Reveal>

      <Reveal delay={0.22} className="mt-8" data-id="element-304" data-mp="iwko3id1tqc1">
        <div className="rounded-[28px] bg-white p-4 shadow-[0_24px_60px_-30px_rgba(0,0,0,0.6)]" data-id="element-305" data-mp="nvxa60w3itdk">
          <div className="grid grid-cols-4 items-end gap-1" data-id="element-306" data-mp="sn5kcz592irs">
            {products.map((p, i) => <motion.div key={p.id} initial={{
            opacity: 0,
            y: 24,
            rotate: i === 0 ? -4 : i === products.length - 1 ? 4 : 0
          }} animate={{
            opacity: 1,
            y: 0,
            rotate: 0
          }} transition={{
            delay: 0.34 + i * 0.12,
            type: 'spring',
            stiffness: 240,
            damping: 20
          }} className="flex flex-col items-center" data-id="element-307" data-mp="wo8ynh7ng6qw" data-mpi={i}>
                <ProductVisual product={p.id} className="h-[126px] w-auto" data-id="element-308" data-mp="1kdjrmcircwuh" />
              </motion.div>)}
          </div>
          <div className="mt-4 grid grid-cols-4 gap-1.5 border-t border-[rgba(1,51,43,0.1)] pt-3 text-center" data-id="element-309" data-mp="1pezbi1978xba">
            {products.map(p => <span key={p.id} className="font-body text-[9px] uppercase leading-tight tracking-[0.1em] text-[rgba(1,51,43,0.55)]" data-id="element-310" data-mp="3hdo2vw9dn0e0">
                {p.shortName}
              </span>)}
          </div>
        </div>
      </Reveal>

      <Reveal delay={0.5} className="mt-7" data-id="element-311" data-mp="32p1obwrkqcnu">
        <PillButton tone="dark" full onClick={onNext} data-id="element-312" data-mp="32nqjdtme6yv5">
          Introduce me
        </PillButton>
      </Reveal>
    </div>;
}